function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 90%;\n  display: flex;\n  margin: 0 auto;\n  justify-content: center;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  padding: 10px;\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  & svg {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import React, { PureComponent, Children } from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import Button from "../button";
import { MutedText, MediumText, EngravedText, CenteredText } from "../text";
import { FiChevronsRight, FiChevronsLeft } from "react-icons/fi";
var CarouselContainer = styled.div(_templateObject());
var CardsContainer = styled.div(_templateObject1(), function(param) {
    var containerProps = param.containerProps;
    return (containerProps === null || containerProps === void 0 ? void 0 : containerProps.css) || "";
});
var Dot = styled.div(_templateObject2(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return theme.palette[isActive ? "primary" : "muted"];
});
var DotsContainer = styled.div(_templateObject3());
var CarouselControls = styled.div(_templateObject4());
var Carousel = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(Carousel, PureComponent);
    var _super = _createSuper(Carousel);
    function Carousel() {
        _classCallCheck(this, Carousel);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            offset: 0
        };
        _this.resetOffset = function() {
            return _this.setState({
                offset: 0
            });
        };
        _this.incrementOffset = function() {
            return _this.setOffset(_this.state.offset + (_this.props.pageJumpSize || 1));
        };
        _this.decrementOffset = function() {
            return _this.setOffset(_this.state.offset - (_this.props.pageJumpSize || 1));
        };
        _this.setOffset = function(newOffset) {
            // const maxOffset = this.props.children.length - this.props.pageSize
            _this.setState({
                offset: Math.max(0, newOffset)
            });
        };
        _this.renderChildren = function() {
            var _props = _this.props, children = _props.children, pageSize = _props.pageSize;
            var offset = _this.state.offset;
            var childrenInView = Children.toArray(children).slice(offset, offset + pageSize);
            return childrenInView;
        };
        _this.renderControls = function() {
            var _props = _this.props, renderControls = _props.renderControls, shouldHideControls = _props.shouldHideControls;
            var offset = _this.state.offset;
            var _props1 = _this.props, pageSize = _props1.pageSize, children = _props1.children;
            if (renderControls) {
                return renderControls({
                    decrementOffset: _this.decrementOffset,
                    incrementOffset: _this.incrementOffset,
                    resetOffset: _this.resetOffset,
                    offset: offset,
                    pageSize: pageSize
                });
            }
            if (shouldHideControls && children.length <= pageSize) {
                return null;
            }
            return /*#__PURE__*/ React.createElement(CarouselControls, null, /*#__PURE__*/ React.createElement(Button, {
                disabled: !offset,
                onClick: _this.decrementOffset,
                type: "button",
                asIcon: true,
                small: true,
                outline: true
            }, /*#__PURE__*/ React.createElement(FiChevronsLeft, null)), /*#__PURE__*/ React.createElement(Button, {
                disabled: children.length <= offset + pageSize,
                onClick: _this.incrementOffset,
                type: "button",
                asIcon: true,
                small: true,
                outline: true
            }, /*#__PURE__*/ React.createElement(FiChevronsRight, null)));
        };
        _this.renderDots = function() {
            var _props = _this.props, pageSize = _props.pageSize, pageJumpSize = _props.pageJumpSize, children = _props.children, renderDots = _props.renderDots;
            var offset = _this.state.offset;
            var dotCount = 1 + Math.ceil((children.length - pageSize) / (pageJumpSize || 1));
            var activeIndex = Math.ceil(offset / (pageJumpSize || 1));
            if (renderDots) {
                return renderDots({
                    decrementOffset: _this.decrementOffset,
                    incrementOffset: _this.incrementOffset,
                    resetOffset: _this.resetOffset,
                    offset: offset,
                    pageSize: pageSize,
                    dotCount: dotCount,
                    activeIndex: activeIndex
                });
            }
            return /*#__PURE__*/ React.createElement(DotsContainer, null, Array.from({
                length: dotCount
            }, function(_, i) {
                return /*#__PURE__*/ React.createElement(Dot, {
                    key: i,
                    isActive: i === activeIndex,
                    onClick: function() {
                        return _this.setOffset(i * (pageJumpSize || 1));
                    }
                });
            }));
        };
        return _this;
    }
    var _proto = Carousel.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // Reset offset if children length changes
        if (prevProps.children.length !== this.props.children.length) {
            this.resetOffset();
        }
    };
    _proto.render = function render() {
        var childrenInView = this.renderChildren();
        var noItemsFoundLabel = this.props.noItemsFoundLabel;
        return /*#__PURE__*/ React.createElement(CarouselContainer, null, /*#__PURE__*/ React.createElement(CardsContainer, {
            containerProps: this.props.containerProps
        }, childrenInView.length ? childrenInView : /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, /*#__PURE__*/ React.createElement(MutedText, null, noItemsFoundLabel || "No items found"))))), this.renderDots(), this.renderControls());
    };
    return Carousel;
}(PureComponent);
Carousel.propTypes = {
    children: propTypes.any.isRequired,
    pageSize: propTypes.number,
    pageJumpSize: propTypes.number,
    renderControls: propTypes.func,
    renderDots: propTypes.func,
    shouldHideControls: propTypes.bool,
    containerProps: propTypes.object
};
Carousel.defaultProps = {
    pageSize: 3,
    pageJumpSize: 1,
    renderControls: undefined,
    renderDots: undefined,
    shouldHideControls: true,
    containerProps: {}
};
export default Carousel;
